import * as angular from "angular";


angular
  .module('bringoz.admin')
  .provider('sisence', sisenceProvider);

/* @ngInject */
function sisenceProvider(): any {

  this.initScript = (url) => {
    const fileUrl = `${url}/js/frame.js`
    var script = document.createElement('script');
    script.setAttribute('src',fileUrl);
    document.body.appendChild(script);
  };

  this.$get = () => {
    return {
      initScript: this.initScript
    };
  };
}
